export default __webpack_public_path__ + "static/media/bw_photos_hamptons-3.17a58f50.jpg";